import { buildAssetRenditionUrl } from '#lib/asset-rendition';

export const FACTORY_PUBLIC_ORIGIN = 'https://faterstoragefrance.blob.core.windows.net';
export const FACTORY_PUBLIC_PREFIX = '/public-project-assets/factory/';
export const FACTORY_PREVIEW_EDGE = 1600;

/** Only immutable, public Factory originals can use the public preview cache. */
export const isFactoryPreviewPath = (path: string): boolean =>
  /^(?:westfield-brand\/(?:v[1-9]\d*\/)?|archetypes\/[a-z0-9-]+\/)[a-f0-9]{64}\.(?:jpg|jpeg|png|webp)$/.test(path);

export function factoryPreviewUrl(source: string): string | null {
  const privatePreview = buildAssetRenditionUrl(source, 1024);
  if (privatePreview) return privatePreview;
  try {
    if (source.includes('%') || source.includes('..') || source.includes('\\')) return null;
    const url = new URL(source);
    if (url.origin !== FACTORY_PUBLIC_ORIGIN || url.username || url.password || url.search || url.hash || !url.pathname.startsWith(FACTORY_PUBLIC_PREFIX)) return null;
    const path = url.pathname.slice(FACTORY_PUBLIC_PREFIX.length);
    return isFactoryPreviewPath(path) ? `/api/list/factory-preview/v1/${path}` : null;
  } catch {
    return null;
  }
}
